var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgLock = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22.183,
    height: 32.168,
    viewBox: "0 0 5.869 8.511",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-30.327 -137.863)"
  }, /*#__PURE__*/React.createElement("g", {
    display: "inline",
    transform: "matrix(.35278 0 0 -.35278 -321.706 328.333)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#999",
    fillOpacity: 1,
    fillRule: "nonzero",
    stroke: "none",
    d: "M0 0a1.65 1.65 0 00-1.649-1.648h-11.456A1.65 1.65 0 00-14.754 0v11.457a1.65 1.65 0 001.649 1.648h11.456A1.65 1.65 0 000 11.457zm-11.822 16.147a4.45 4.45 0 004.445 4.446 4.45 4.45 0 004.444-4.446v-2.009h-8.889zm10.173-2.099h-.341v2.099a5.394 5.394 0 01-5.387 5.388 5.394 5.394 0 01-5.388-5.388v-2.099h-.34a2.594 2.594 0 01-2.591-2.591V0a2.594 2.594 0 012.591-2.591h11.456A2.593 2.593 0 01.941 0v11.457a2.594 2.594 0 01-2.59 2.591",
    display: "inline",
    transform: "translate(1013.585 518.38)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1006.208 522.234)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#999",
    fillOpacity: 1,
    fillRule: "nonzero",
    stroke: "none",
    d: "M0 0a1.877 1.877 0 00-1.875 1.874c0 1.033.841 1.874 1.875 1.874a1.877 1.877 0 001.874-1.874A1.877 1.877 0 000 0m0 4.69a2.82 2.82 0 01-2.817-2.816A2.82 2.82 0 010-.942a2.819 2.819 0 012.816 2.816A2.819 2.819 0 010 4.69"
  }))))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgLock);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/lock.8cc6f6f1bd882459b026f523b12607f6.svg";